import { Preview } from "@creatomate/preview";
import { Subtitle } from "chq";
import { errorService } from "app/utils";
import deleteElement from "components/stories/video-studio/utils/creatomate/deleteElement";

const deleteSection = async (
  preview: Preview,
  subtitles: Subtitle[],
  sectionIndex: number,
  handleUpdateData: (newData: Record<string, any>) => void
): Promise<Subtitle[]> => {
  const updatedSubtitles = await Promise.all(subtitles.map(async subtitle => {
    const updatedSections = subtitle.sections ? [...subtitle.sections] : [];
    const section = updatedSections[sectionIndex];

    if (section?.creatomateId) {
      try {
        await deleteElement(preview, section.creatomateId);
      } catch (error) {
        errorService.error(`Failed to delete element with ID ${section.creatomateId}:`, error);
      }
    }

    updatedSections.splice(sectionIndex, 1);
    return { ...subtitle, sections: updatedSections };
  }));
  handleUpdateData({ subtitles: updatedSubtitles });
  return updatedSubtitles;
};

export default deleteSection;
